/* global fetch */

import { config } from '../config';
import { headers, stleaf, SpanTag, tracer, getPublicTokens } from '../helpers';
import { FORMAT_HTTP_HEADERS } from '@birdi/tracing';

// Internal function that mimics doFetchTagged behavior for binary data
async function fetchTileWithTracing(
  tag: string,
  url: string,
  args: RequestInit,
): Promise<ArrayBuffer> {
  let bodysize = null;
  if (args.body) {
    bodysize = (args.body as any).size || (args.body as any).length;
  }

  const span = tracer.start_span('fetch', {
    tags: {
      'span.kind': 'client',
      'window.location': window.location.toString(),
      'http.url': url,
      'http.method': args.method,
      ...(bodysize && { bodysize }),
      ...(tag && { tag }),
    },
  });

  let headers = {};
  const tokens = getPublicTokens();

  // Build custom headers with token and mapId if available
  const customHeaders = { ...args.headers };
  if (tokens.token) customHeaders['X-Auth-Token'] = tokens.token;
  if (tokens.mapId) customHeaders['X-Map-ID'] = tokens.mapId;

  if (args.headers) {
    headers = JSON.parse(JSON.stringify(customHeaders));
  }

  tracer.span_inject(span, FORMAT_HTTP_HEADERS, headers);
  args.headers = headers;
  args.headers['x-birdi-context'] = tag || 'unknown';

  let responded = false;

  try {
    const response = await fetch(url, args);
    responded = true;

    span.logEvent('response_status', response.status);

    if (!response.ok) {
      throw new Error(`Failed to fetch tile: ${response.status}`);
    }

    const tileBuffer = await response.arrayBuffer();
    span.logEvent('resolution_status', true);

    return tileBuffer;
  } catch (err) {
    span.catch(err);
    err.birdi_context = tag || 'unknown';

    if (!responded) {
      const { name } = err;
      err = new Error('Network Error');
      if (name) err.name = name;
      err.birdi_context = tag || 'unknown';
    }

    throw err;
  } finally {
    span.finish();
  }
}

export const getTile = (
  st: SpanTag,
  z: string,
  x: string,
  y: string,
): Promise<ArrayBuffer> => {
  const url = `${config.API_URL}/v1/aws-maps/tiles/${z}/${x}/${y}`;

  return fetchTileWithTracing(st.tag, url, {
    method: 'GET',
    headers: {
      Accept: 'image/*',
    },
  });
};
